import React from 'react';
import { useResizeObserver } from 'owa-react-hooks/lib/useResizeObserver';
import FavoriteNode from './FavoriteNode';
import { sideRailNodeWrapper } from './FavoritesSideRail.scss';
import getSiderailFavoriteTooltipText from '../util/getSiderailFavoriteTooltipText';

export interface FavoritesSideRailNodeProps {
    favoriteId: string;
    hideIcon: boolean;
    onHeightChange: (favoriteId: string, height: number) => void;
}

const FavoritesSideRailNode: React.FunctionComponent<FavoritesSideRailNodeProps> =
    function FavoritesSideRailNode({ favoriteId, hideIcon, onHeightChange }) {
        const wrapperRef = React.useRef<HTMLDivElement>(null);

        const onResize = React.useCallback(
            (bounds: DOMRectReadOnly) => {
                onHeightChange(favoriteId, bounds.height);
            },
            [favoriteId, onHeightChange]
        );
        useResizeObserver('FavoritesSideRailNode', wrapperRef, onResize);

        return (
            <div ref={wrapperRef} className={sideRailNodeWrapper}>
                <FavoriteNode
                    favoriteId={favoriteId}
                    isVerticalNode={true}
                    hideIcon={hideIcon}
                    actionSource="FavoritesSiderail"
                    customTreeNodeTooltip={getSiderailFavoriteTooltipText(favoriteId)}
                />
            </div>
        );
    };

export default FavoritesSideRailNode;
